export default {
  data() {
    return {
      electron: null,
      // selfEleWinId: null,
      selfEleWin: null, // the browserwindow instance of this page
    };
  },
  created() {
    try {
      // eslint-disable-next-line
      const electron = eval("require('electron')");
      this.electron = electron;
      this.selfEleWin = electron.remote.getCurrentWindow(); // 是同步的方法吧？
      // this.selfEleWinId = electron.remote.getCurrentWindow().id;
      this.selfEleWin.focus(); //需要聚焦吗？
      this.selfEleWin.maximize(); //最大化
      const isMock = this.$route.path.match(/^\/mock(E|e)xam/) || this.$route.query.mock === '1';
      if (!isMock) {
        this.selfEleWin.setResizable(false); //设置不可改变大小
        this.selfEleWin.setMinimizable(false); //设置不可最小化
      }
    } catch (err) {
      console.log('Not in an electron environment;');
    }
  },
};
